import { IGetCustomerList } from '#types/confirmationForms';
import { useState } from 'react';
import ItemList from './ItemList';

interface GroupProps extends IGetCustomerList {}

const Group = ({ lecture, id, person }: GroupProps) => {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
    const day = date.getDate().toString().padStart(2, '0'); // Get the day of the month

    return `${year}.${month}.${day}`;
  }

  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex flex-col gap-20">
      <div
        onClick={onClick}
        className="w-full h-[77px] py-12 px-16 bg-[#373245] rounded-lg justify-between items-center inline-flex"
      >
        <div className="flex-col justify-center items-start gap-4 inline-flex">
          <div className="text-[#d7d2de] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            {lecture.title}
          </div>
          <div className="text-[#938f9e] text-sm font-normal font-['Pretendard Variable'] leading-tight">
            {formatDate(lecture.createdAt)} - {}
          </div>
        </div>

        <div style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.00033 5.1665L8.00033 9.1665L12.0003 5.1665L13.3337 6.49984L8.00033 11.8332L2.66699 6.49984L4.00033 5.1665Z"
              fill="#948F9E"
            />
          </svg>
        </div>
      </div>

      {isOpen && <ItemList id={id} personId={person.id} />}
    </div>
  );
};

export default Group;
